import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import i18n from "../../../functions/i18next";

export default {
  props: {
    id: String,
  },
  data() {
    return {
      roleId: null,
      name: "",
      key: 0,
      role: {},
      rights: [],
      right: "",
      openCategories: [],
      openSpaces: [],
      spaces: {},
      spacesUpdate: [],
      categories: [],
      subcategories: [],
      stateCategory: "category",
      error: "",
      errorMessage: "",
      edited: false,
      expanded: false,
      categoryRight: 0,
      spaceRight: 0,
      titleToIcon: {
        spaces: "space",
        folders: "folder",
        files: "file--simple",
        tags: "tag",
        faces: "user",
        notifications: "notify",
        "copy/paste": "copy",
        admin: "gear",
        users: "users",
        roles: "users",
        branding: "branding",
        collect: "collect",
        transfer: "transfer",
        "quick transfer": "transfer",
        "my space": "myspace",
      },
      toolTipText: {
        spaces: i18n.t("tooltip.space"),
        folders: i18n.t("tooltip.folders"),
        files: i18n.t("tooltip.files"),
        tags: i18n.t("tooltip.tags"),
        faces: i18n.t("tooltip.faces"),
        notifications: i18n.t("tooltip.notifications"),
        "copy/paste": i18n.t("tooltip.copy_paste"),
        admin: i18n.t("tooltip.admin"),
        users: i18n.t("tooltip.users"),
        roles: i18n.t("tooltip.roles"),
        branding: i18n.t("tooltip.branding"),
        collect: i18n.t("tooltip.collect"),
        transfer: i18n.t("tooltip.transfer"),
        "quick transfer": i18n.t("tooltip.quick_transfer"),
        "my space": i18n.t("tooltip.my_space"),
      },
    };
  },
  created() {
    if (this.id) {
      this.$axios.get(baseUrl + "/role?id=" + this.id).then((response) => {
        this.role = response.data.role;
        this.rights = response.data.rights;
        this.name = this.role.name;
        this.spaces = {};
        this.setCategories(this.rights);
        this.setSpaces(response.data.spaces);
      });
    }
  },
  methods: {
    setSpaces(spaces) {
      this.spaces = spaces;
    },
    setCategories(rights) {
      this.categories = [];

      for (let right in rights) {
        let category = [];
        let subCategory = [];
        let title;

        // set the category title
        if (right.includes("_")) {
          title = right.split("_")[1];
          title = this.getTitle(title);
          this.findCategory(title);

          if (this.stateCategory === "category") {
            category.title = title;
            category.value = 1;
            if (title === "files") {
              category.active = false;
              category.rights = [];
              category.subcategories = [];
              this.categories.push(category);
              if (this.name.toLowerCase() != "public") {
                let adminObj = [];
                adminObj.title = "admin";
                adminObj.value = 1;
                adminObj.active = false;
                adminObj.subcategories = [];
                this.categories.push(adminObj);
              }
            } else {
              category.active = false;
              category.rights = [];
              this.categories.push(category);
            }
          }

          if (this.stateCategory === "subCategory") {
            subCategory.title = title;
            if (
              title === "tags" ||
              title === "faces" ||
              title === "notifications"
            ) {
              subCategory.parent = "files";
            } else {
              subCategory.parent = "admin";
            }
            this.subcategories.push(subCategory);
          }
        } else {
          title = right;
          title = this.getTitle(title);
          category.title = title;
          category.value = this.rights[right];
          category.right = right;
          this.categories.push(category);
        }
      }

      for (let category in this.categories) {
        let found = false;
        if (this.categories[category].rights) {
          let title;
          let categoryRight = [];
          for (let right in rights) {
            let item = [];
            if (right.includes(this.categories[category].title)) {
              title = right.split("_")[0];
              item.title = this.getTitle(title);
              item.value = this.rights[right];
              item.right = right;
              categoryRight.push(item);

              if (this.rights[right] == 0) {
                found = true;
              }
            }
          }
          this.categories[category].rights = categoryRight;
        }

        if (this.categories[category].subcategories) {
          if (this.categories[category].title === "files") {
            let subCategories = [];
            let item = [];
            let rights_array = [];
            let title;

            title = "tags";
            item.title = title;
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            item = [];
            rights_array = [];
            title = "faces";
            item.title = title;
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            item = [];
            rights_array = [];
            title = "notifications";
            item.title = "notifications";
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            this.categories[category].subcategories = subCategories;
          }

          if (this.categories[category].title === "admin") {
            let subCategories = [];
            let item = [];
            let rights_array = [];
            let title;

            title = "users";
            item.title = title;
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            item = [];
            rights_array = [];
            title = "roles";
            item.title = title;
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            item = [];
            rights_array = [];
            title = "branding";
            item.title = title;
            rights_array = this.getRights(title, rights);
            item.rights = rights_array;
            if (rights_array[0].value === 0) {
              found = true;
            }
            subCategories.push(item);

            this.categories[category].subcategories = subCategories;
          }
        }

        if (found) {
          this.categories[category].value = 0;
        }
      }
    },
    getRights(title, rights) {
      let items = [];
      for (let right in rights) {
        let item = [];
        if (right.includes(title)) {
          let rightTitle = right.split("_")[0];
          item.title = this.getTitle(rightTitle);
          item.value = this.rights[right];
          item.right = right;
          items.push(item);
        }
      }
      return items;
    },
    getTitle(title) {
      if (title.includes("-")) {
        title = title.replace("-", " ");
      }

      if (title.includes("+")) {
        title = title.replace("+", "/");
      }

      return title;
    },
    findCategory(title) {
      this.stateCategory = "category";
      if (
        title === "tags" ||
        title === "faces" ||
        title === "notifications" ||
        title === "users" ||
        title === "roles" ||
        title === "branding"
      ) {
        this.stateCategory = "subCategory";
      } else {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i].title === title) {
            this.stateCategory = "found";
            break;
          }
        }
      }
    },
    setDesc(title) {
      return this.toolTipText[title];
    },
    setIcon(title) {
      return this.titleToIcon[title] ? this.titleToIcon[title] : "space";
    },
    updateRight(right, value) {
      if (value === 0) {
        this.$set(this.rights, right, 1);
        this.setCategories(this.rights);
      }
      if (value === 1) {
        this.$set(this.rights, right, 0);
        this.setCategories(this.rights);
      }
    },
    submitSpaceRights() {
      let blockedList = "";

      let keys = Object.keys(this.spaces);
      keys.forEach((key) => {
        let item = this.spaces[key];
        blockedList += item.id + "," + item.checked + ";";
      });

      // this.spaces.forEach((item, index) => {
      //     blockedList+=item.id + ',' +item.checked + ';';
      // });

      let formData = new FormData();
      formData.append("id", this.role.id);
      formData.append("blockedList", blockedList);

      this.$axios
        .post(baseUrl + "/updateroleAccess", formData)
        .then((response) => {
          if (response.data) {
            this.edited = true;
          } else {
            this.edited = false;
            this.error = true;
            this.errorMessage = "Something went wrong.";
          }
        });
    },
    submit() {
      let formData = new FormData();
      formData.append("id", this.role.id);
      formData.append("name", this.name);
      formData.append("rights", JSON.stringify(this.rights));

      this.$axios.post(baseUrl + "/updaterole", formData).then((response) => {
        if (response.data) {
          this.edited = true;
        } else {
          this.edited = false;
          this.error = true;
          this.errorMessage = "Something went wrong.";
        }
      });
    },
    close() {
      EventBus.$emit("close-manage-user-actions");
    },
    back() {
      this.edited = false;
      this.setCategories(this.rights);
    },
    setOpen(title) {
      if (this.openCategories.length === 0) {
        this.openCategories.push(title);
      } else {
        if (this.openCategories.includes(title)) {
          this.openCategories = this.openCategories.filter(function (el) {
            return el !== title;
          });
        } else {
          this.openCategories.push(title);
        }
      }
    },
    setExpanded() {
      if (this.expanded) {
        this.expanded = false;
        this.openCategories = [];
      } else {
        this.expanded = true;
        for (let category in this.categories) {
          let title = this.categories[category].title;
          if (!this.openCategories.includes(title)) {
            this.openCategories.push(title);
          }
        }
      }
    },
    checkSpace(id, checked) {
      let data = this.spaces[id];
      data.checked = checked === 1 ? 0 : 1;
      this.$set(this.spaces, id, data);
    },
    checkCategory(title, value) {
      if (value == 0) {
        for (let category in this.categories) {
          let parent = this.categories[category];
          if (parent.title == title) {
            for (let item in parent.rights) {
              let right = parent.rights[item].right;
              this.$set(this.rights, right, 1);
            }
            for (let item in parent.subcategories) {
              for (let sub in parent.subcategories[item]) {
                let subcategory = parent.subcategories[item][sub];
                for (let right in subcategory) {
                  if (subcategory[right].right != undefined) {
                    this.$set(this.rights, subcategory[right].right, 1);
                  }
                }
              }
            }
            this.setCategories(this.rights);
          }
        }
      } else {
        for (let category in this.categories) {
          let parent = this.categories[category];
          if (parent.title == title) {
            for (let item in parent.rights) {
              let right = parent.rights[item].right;
              this.$set(this.rights, right, 0);
            }

            for (let item in parent.subcategories) {
              for (let sub in parent.subcategories[item]) {
                let subcategory = parent.subcategories[item][sub];
                for (let right in subcategory) {
                  if (subcategory[right].right != undefined) {
                    this.$set(this.rights, subcategory[right].right, 0);
                  }
                }
              }
            }
            this.setCategories(this.rights);
          }
        }
      }
    },
    sanitizeClass(input) {
      return input.replace("/", "_");
    },
  },
  computed: {
    hasSpaces() {
      return Object.keys(this.spaces).length;
    },
  },
};
